import React, { useState, useEffect } from 'react';
import { updateSss } from '../../services/sssService';
import { SuccessCircle, WarningIcon } from '../../assets/icons';
import Spinner from '../common/Spinner';
import useModalClose from '../../hooks/useModalClose';

const STEPS = {
  FORM: 0,
  CONFIRM: 1,
  COMPLETE: 2
};

 

const EditSssModal = ({ isOpen, onClose, user, onSuccess }) => {
  const [currentStep, setCurrentStep] = useState(STEPS.FORM);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
 
  });
  const [updatedUser, setUpdatedUser] = useState(null);

  useEffect(() => {
    if (user) {
      setFormData({
        soru: user.soru,
        cevap: user.cevap,
        sira: user.sira,

      });
    }
  }, [user]);

  const resetState = () => {
    setCurrentStep(STEPS.FORM);
    setIsLoading(false);
    setError(null);
    setUpdatedUser(null);
  };

  useEffect(() => {
    if (!isOpen) {
      resetState();
    }
  }, [isOpen]);

  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    
  };

  const validateForm = () => {
    if (!formData.soru ||!formData.cevap || !formData.sira) {
      setError('Lütfen tüm alanları doldurunuz.');
      return false;
    }
    
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    
    if (validateForm()) {
      setCurrentStep(STEPS.CONFIRM);
    }
  };

  const handleBack = () => {
    setCurrentStep(STEPS.FORM);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    setError(null);
    setCurrentStep(STEPS.COMPLETE);

    try {
      await updateSss(user.id, {
        ...formData,
        aktifMi: true
      });
      const updatedUserData = {
        ...user,
        ...formData,
        role: parseInt(formData.role)
      };
      setUpdatedUser(updatedUserData);
      onSuccess(updatedUserData);
    } catch (error) {
      setError('Kayıt  güncellenirken bir hata oluştu.');
      console.error('Update user error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderStepIndicator = () => (
    <div className="stepper">
      <div className={`step ${currentStep >= STEPS.FORM ? 'active' : ''}`}>
        <div className="step-circle">
          {currentStep >= STEPS.FORM && <div className='step-active-circle' />}
        </div>
        <span className="step-title">Kayıt Bilgileri</span>
      </div>
      <div className={`step ${currentStep >= STEPS.CONFIRM ? 'active' : ''}`}>
        <div className="step-circle">
          {currentStep >= STEPS.CONFIRM && <div className='step-active-circle' />}
        </div>
        <span className="step-title">Bilgi Onayı</span>
      </div>
      <div className={`step ${currentStep >= STEPS.COMPLETE ? 'active' : ''}`}>
        <div className="step-circle">
          {currentStep >= STEPS.COMPLETE && <div className='step-active-circle' />}
        </div>
        <span className="step-title">Tamamlandı</span>
      </div>
    </div>
  );

  const renderForm = () => (
    <form onSubmit={handleSubmit} className="create-user-form">
      <div className="form-group">
        <label htmlFor="name">Soru</label>
        <input
          type="text"
          id="soru"
          name="soru"
          value={formData.soru}
          onChange={handleInputChange}
          placeholder="Soru"
        />
      </div>  <div className="form-group">
      <label htmlFor="name">Cevap</label>
      <textarea
  id="cevap"
  name="cevap"
  value={formData.cevap}
  onChange={handleInputChange}
  placeholder="Cevap"
/><style jsx>{`textarea{min-height: 200px;
          padding: 4px;
          border: 2px solid;}
            `}</style>
      </div>  <div className="form-group">
       <label htmlFor="name">Sıra</label>
       <input
         type="number"
         id="sira"
         name="sira"
         value={formData.sira}
         onChange={handleInputChange}
         placeholder="Sıra"
       />
     </div>
      {error && <div className="error-message">{error}</div>}
      <div className="form-actions">
        <button type="submit" className="submit-button">
            Düzenlemeyi Kaydet
        </button>
      </div>
    </form>
  );

  const renderConfirmation = () => (
    <div className="confirmation-step">
      <WarningIcon />
      <h3>Kayıt bilgilerini güncellemek üzeresiniz. Onaylıyor musunuz?</h3>
      <div className="table-container">
        <table className="users-table">
          <thead>
            <tr>
            <th>Soru</th>
             <th>Cevap</th>
             <th>Sıra</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{`${formData.soru}`}</td>
                  <td>{`${formData.cevap}`}</td>
                  <td>{`${formData.sira}`}</td>
              
            </tr>
          </tbody>
        </table>
      </div>
      <div className="form-actions">
        <button type="button" onClick={handleBack} className="back-button">
          İptal Et
        </button>
        <button type="button" onClick={handleConfirm} className="confirm-button">
          Sonraki Adım
        </button>
      </div>
    </div>
  );

  const renderComplete = () => (
    <div className="complete-step">
      {isLoading ? (
        <div className="loading-state">
          <Spinner size="large" />
          <h3>Süreciniz tamamlanıyor...</h3>
          <button type="button" onClick={handleClose} className="cancel-button">
            Süreci İptal Et
          </button>
        </div>
      ) : updatedUser ? (
        <div className="success-state">
          <SuccessCircle />
          <h3>Süreciniz tamamlandı. Kayıt bilgileri güncellendi.</h3>
          <div className="table-container">
            <table className="users-table">
              <thead>
                <tr>
                <th>Soru</th>
             <th>Cevap</th>
             <th>Sıra</th>
                 
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{`${updatedUser.soru}`}</td>
                  <td>{`${updatedUser.cevap}`}</td>
                  <td>{`${updatedUser.sira}`}</td>
                 
                </tr>
              </tbody>
            </table>
          </div>
          <button type="button" onClick={handleClose} className="close-button">
            Kapat
          </button>
        </div>
      ) : (
        <div className="error-state">
          <div className="error-icon">✕</div>
          <h3>Hata Oluştu</h3>
          <p>{error}</p>
          <button type="button" onClick={handleBack} className="retry-button">
            Tekrar Dene
          </button>
        </div>
      )}
    </div>
  );

  // Add modal closing behaviors
  useModalClose(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Kayıt Bilgilerini Düzenle</h3>
        </div>
        {renderStepIndicator()}
        <div className="modal-body">
          {currentStep === STEPS.FORM && renderForm()}
          {currentStep === STEPS.CONFIRM && renderConfirmation()}
          {currentStep === STEPS.COMPLETE && renderComplete()}
        </div>
      </div>
    </div>
  );
};

export default EditSssModal; 